import React, {Component} from 'react';

class DarkMode extends Component {
	/**
	 * Render the component into html.
	 */
	render () {
		const {className} = this.props;

		return <div {...this.props} className={`icon-dark-mode ${className ? className : ''}`}>
			<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="img"
			     viewBox="0 0 20 20">
				<path fill="currentColor"
				      d="M11.432,4.822a.766.766,0,0,0-.293.071A10.425,10.425,0,0,0,15.46,24.82a10.528,10.528,0,0,0,9.468-6.139.766.766,0,0,0-1.054-1A8.679,8.679,0,0,1,12.139,5.946a.766.766,0,0,0-.707-1.125Z"
				      transform="translate(-5 -4.821)"/>
			</svg>
		</div>;
	}
}

export default DarkMode;
